import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/estados-de-las-infracciones/';

/**
 * GET EstadosDeInfracciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getEstadosDeInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Estadoso De Infraccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadosoDeInfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST EstadosoDeInfraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadosoDeInfraccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH EstadosoDeInfraccion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadosoDeInfraccion = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Estadoso De Infraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadosoDeInfraccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
